/* eslint no-use-before-define: 0 */

import CarouselComponent from "./carousel.component";
import {
    tileListReloaded$,
    fireSearchErrorsRequested,
    carouselInitializationRequested$,
} from "../globalEvents";

const { $ } = window;

export default class CarouselInstanceManager {
    constructor() {
        this.carousels = [];

        this.initialize();
    }

    /**
     * @private
     */
    initialize() {
        const scope = this;
        const isAnyCarouselExists = createCarouselsFromHTML();
        if (isAnyCarouselExists) {
            displayNotLoadedTextIfNeed();
        }
        subscribeOnEvents();

        function displayNotLoadedTextIfNeed() {
            const width = $(".sitecore-carousel-component .slick-track").eq(0).width();
            if (width !== 0) {
                $(".carousel-not-loaded-yet-text").remove();
            }
        }
        /**
         * @returns {Number} - amount of initialized CarouselComponent(s)
         */
        function createCarouselsFromHTML() {
            const carouselComponents = $(".sitecore-carousel-component");
            $.each(carouselComponents, function createCarouselComponent() {
                if ($(this).data("load-on-demand") !== "True" && !$(this).hasClass("slick-initialized")) {
                    scope.carousels.push(new CarouselComponent($(this)));
                }
            });
            if (carouselComponents.length) {
                fireSearchErrorsRequested();
            }
            return carouselComponents.length;
        }

        function subscribeOnEvents() {
            subscribeToCarouselInitializationByDemand();
            subcribeToTileListReload();

            function subscribeToCarouselInitializationByDemand() {
                carouselInitializationRequested$.subscribe((carouselNode) => {
                    if (carouselNode.data("load-on-demand") === "True" && !carouselNode.hasClass("ready")) {
                        scope.carousels.push(new CarouselComponent(carouselNode));
                    } else if (carouselNode.data("load-on-demand") === "True") {
                        /**
                         * We're recreating Slick part of carousel here
                         */
                        carouselNode.slick("unslick");

                        const carouselObj = scope.carousels.find(x => x.carouselNode[0] === carouselNode[0]);

                        carouselNode.slick(carouselObj.slickConfig);
                    }
                });
            }

            function subcribeToTileListReload() {
                tileListReloaded$.subscribe(() => {
                    const carouselComponents = $(".sitecore-carousel-component:not(.ready)");
                    $.each(carouselComponents, function createCarouselComponent() {
                        if ($(this).data("load-on-demand") !== "True") {
                            scope.carousels.push(new CarouselComponent($(this)));
                        }
                    });
                    if (carouselComponents.length) {
                        fireSearchErrorsRequested();
                    }
                });

                /**
                 * After insert more carousel it might be required to show message user should press 'save' btn.
                 */
                tileListReloaded$.subscribe(() => displayNotLoadedTextIfNeed());
            }
        }
    }
}
